/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  operations: undefined,
  promoCodes: undefined,
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setOperations: (state, { payload: data }) => {
      state.operations = data?.data || [];
    },
    setPromoCodes: (state, { payload: data }) => {
      state.promoCodes = data;
    },
    resetHomeReducer: () => initialState,
  },
});

// export the reducer
export const homeReducer = homeSlice.reducer;

// export the selector
export const homeSelector = (state) => state?.homeReducer;

// export the actions
export const { setOperations, setPromoCodes, resetHomeReducer } =
  homeSlice.actions || {};
